import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CourseSectionService } from '../../services/course-section.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { environment } from 'src/environments/environment';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-registered-course',
  templateUrl: './registered-course.component.html',
  styleUrls: ['./registered-course.component.scss']
})
export class RegisteredCourseComponent implements OnInit, OnDestroy {


  registeredCourses: any[] = [];
  loading = false;
  limit = 10;
  offset = 0;
  endOfData = false;
  allDataLoaded = false;
  initialLoadDone = false;
  openFilter = false;
  searchControl = new FormControl('');
  private destroy$ = new Subject<void>();
  private currentSearchTerm = '';
  getCourseType: any[] = [];
  filteredCourseTypes: any[] = [];
  filterType = '';
  private lastTypeSearch = '';
  private typeInput$ = new Subject<string>();
  private categoryInput$ = new Subject<string>();


  getCourseCategories: any[] = []; 
  filteredCourseCategories: any[] = [];
  filterCategory: string = '';
  lastCategorySearch: string = '';
  dataLoader = false;

  constructor(
    private courseSectionService: CourseSectionService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.fetchRegisteredCourses();

    //  Debounced search
    this.searchControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((value: string) => {
        const term = value?.trim();
        if (term === this.currentSearchTerm) return;
        this.currentSearchTerm = term || '';
        // reset pagination on new search
        this.offset = 0;
        this.registeredCourses = [];
        this.allDataLoaded = false;
        this.dataLoader = true;
        this.fetchRegisteredCourses();
      });

    // Debounced TYPE input: only filter list, do NOT fetch API
    this.typeInput$
      .pipe(debounceTime(500), distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((value: string) => {
        const trimmedValue = (value || '').trim();
        if (!trimmedValue) {
          this.filteredCourseTypes = [...this.getCourseType];
          return;
        }
        this.filteredCourseTypes = this.getCourseType.filter(ct =>
          (ct.name || '').toLowerCase().includes(trimmedValue.toLowerCase())
        );
      });
    // Debounced CATEGORY input: only filter list, do NOT fetch API
    this.categoryInput$
      .pipe(debounceTime(500), distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((value: string) => {
        const trimmedValue = (value || '').trim();
        if (!trimmedValue) {
          this.filteredCourseCategories = [...this.getCourseCategories];
          return;
        }
        this.filteredCourseCategories = this.getCourseCategories.filter(cat =>
          (cat.name || '').toLowerCase().includes(trimmedValue.toLowerCase())
        );
      });
  }

  // Modify your input handlers to emit values instead of direct logic
  onTypeInput(value: string): void {
    this.typeInput$.next(value);
  }

  onCategoryInput(value: string): void {
    this.categoryInput$.next(value);
  }


  fetchRegisteredCourses() {
    if (this.loading || this.allDataLoaded) return;

    this.loading = true;

    this.courseSectionService.getRegisteredCourses(
      this.limit,
      this.offset,
      this.currentSearchTerm,
      this.filterType,
      this.filterCategory,
      this.filterMonth
    ).subscribe({
      next: (result: any) => {
        const newCourses = result?.data?.courses || [];        

        if (newCourses.length > 0) {
          this.registeredCourses = [...this.registeredCourses, ...newCourses];
          this.offset += this.limit;

          // **Check if returned count < limit, meaning we've reached the end**
          if (newCourses.length < this.limit) {
            this.allDataLoaded = true;
          }
        } else {
          this.allDataLoaded = true;
        }

        this.dataLoader = false;
        this.loading = false;
        this.initialLoadDone = true;
        this.spinner.hide();
      },
      error: (err) => {
        console.error('Error fetching registered courses', err);
        this.loading = false;
        this.dataLoader = false;
        this.initialLoadDone = true;
        this.spinner.hide();
      }
    });
  }

  onScroll() {
    if (this.loading || this.allDataLoaded) return;
    this.fetchRegisteredCourses();
  }

  trackByRegId(index: number, item: any): string {
    return item.id;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // filter 

  toggleFilter(): void {
    this.openFilter = !this.openFilter;


    if (this.openFilter) {
      if (!this.getCourseType.length) {
        this.getCourseTypes();
      }
      if (!this.getCourseCategories.length) {
        this.getCourseCatagories();
      }
    }


  }

  // TYPE FILTER
  getCourseTypes(): void {
    this.courseSectionService.getCourseType().subscribe((res: any) => {

      this.getCourseType = res || [];
      this.filteredCourseTypes = [...this.getCourseType];

    });
  }


  onTypeSelected(selectedName: string): void {
    this.filterType = selectedName;
    this.filteredCourseTypes = [...this.getCourseType];
    this.lastTypeSearch = selectedName.trim();
    this.refreshCurrentTabData();
  }
  onTypeScrolled(index: number): void {
    if (index + 5 >= this.filteredCourseTypes.length) {
      this.getCourseTypes();
    }
  }

  refreshCurrentTabData(): void {
    this.offset = 0;
    this.endOfData = false;
    this.registeredCourses = [];
    this.allDataLoaded = false;
    this.dataLoader = true;
    this.fetchRegisteredCourses();
  }

  // --- CATEGORY FILTER ---



  getCourseCatagories(): void {
    this.courseSectionService.getCourseCategories().subscribe((res: any) => {
      this.getCourseCategories = res || [];
      this.filteredCourseCategories = [...this.getCourseCategories];
    });
  }



  onCategorySelected(selectedName: string): void {
    this.filterCategory = selectedName;
    this.filteredCourseCategories = [...this.getCourseCategories];
    this.lastCategorySearch = selectedName.trim();
    this.refreshCurrentTabData();
  }

  onCategoryScrolled(index: number): void {
    if (index + 5 >= this.filteredCourseCategories.length) {
      this.getCourseCatagories(); // Load more if required
    }
  }


  filterMonth: string = "";
  selectedMonth: Date | null = null;

  chosenDateHandler(date: Date | null): void {
    if (!date) {
      this.selectedMonth = null;
      this.filterMonth = "";
      this.offset = 0;
      this.endOfData = false;
      this.allDataLoaded = false; // reset
      this.registeredCourses = [];
      this.dataLoader = true;
      this.fetchRegisteredCourses();
      return;
    }

    this.selectedMonth = date;

    // Convert to 'yyyy-MM-dd' format
    const formatted = this.datePipe.transform(date, 'yyyy-MM-dd');
    this.filterMonth = formatted ?? '';

    this.offset = 0;
    this.endOfData = false;
    this.allDataLoaded = false;
    this.registeredCourses = [];
    this.fetchRegisteredCourses();
  }



  clearAllFilters(): void {
    const hadFilters =
      (this.filterType && this.filterType.trim() !== '') ||
      (this.filterCategory && this.filterCategory.trim() !== '') ||
      (this.filterMonth && this.filterMonth.trim() !== '');

    this.filterType = '';
    this.filterCategory = '';
    this.filterMonth = '';
    this.selectedMonth = null;

    this.filteredCourseTypes = [...this.getCourseType];
    this.lastTypeSearch = '';
    this.filteredCourseCategories = [...this.getCourseCategories];
    this.lastCategorySearch = '';

    if (hadFilters) {
      this.refreshCurrentTabData();
    }
  }


    getFirstApprovedUser(userList: any[]): any | null {
      
  if (!userList || userList.length === 0) return null;
  return userList.find(user => user.webinar_status === 'APPROVED') || null;
}


getWebinarChip(data: any[]) {
  return data?.find(d => d.status === 'PENDING' || d.status === 'APPROVED')?.webinar_status || null;
}


hasCancelled(users: any[], statusToCheck: string): boolean {

  return users.every(user => user.status === statusToCheck);
}

hasCompleted(data: any[]) {
  return data?.some(d => d.status === 'COMPLETED');
}


// download certificate 
//   downloadCertificate(CertificateData:any) {
    
//   const url = `${environment.serverPath}/api/v1/auth/download-certificate`;   
//   // const url = `http://localhost:5000/api/v1/auth/download-certificate`;   
  

//   const userData = CertificateData?.course_registered_users.find(data => data.status === 'COMPLETED');
  

// function formatDate(dateStr: string): string {
//   const dateObj = new Date(dateStr);
//   return dateObj.toLocaleDateString('en-US', {
//     year: 'numeric',
//     month: 'long',
//     day: 'numeric'
//   });
// }

// const formattedStart = formatDate(CertificateData?.startDate);
// const formattedEnd = formatDate(CertificateData?.endDate);


//   // sample data to send
//   const data = {
//     first_name: userData?.first_name,
//     last_name: userData?.last_name,
//     presenters : CertificateData?.presenters,
//     // presenters : CertificateData?.presenters?.map(p => p.presented_by_name) || [],
//     course_name : CertificateData?.course_name,
//     logo: CertificateData?.dental_supplier?.logo,
//     company_name: CertificateData?.company_name,
//     startDate:formattedStart,
//     endDate: formattedEnd,
//     cpd_points: CertificateData?.cpd_points

//   };

//   this.http.post(url, data, { responseType: 'blob' }).subscribe((blob) => {

//     const link = document.createElement('a');
//     link.href = window.URL.createObjectURL(blob);
//     link.download = `Certificate_${data.first_name}.pdf`;
//     link.click();
//   }, (err) => {
//     console.error('Error downloading PDF', err);
//   });
// }



// testing static
 testDownloadCertificate() {
    
  const url = `${environment.serverPath}/api/v1/auth/test-certificate`; 
  // const url = `http://localhost:5000/api/v1/auth/test-certificate`;  

  // sample data to send
  const data = {
    first_name: "sarathi",
    last_name: "P",
    company_name: "dentalbusiness update",
    course_name: "Dental Course",
    cpd_points: 4.4,
    endDate: "November 21, 2025",
    logo: "https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360/project/d2597dd7-cee5-4967-a7e8-b89ac21f4392",

    presenters: [
      {
          presented_by_name: "abhraham ",
          presented_by_image: {
            name: "morgan.jfif",
            size: 5131,
            type: "image/jpeg",
            url:
              "https://dentalerp-dev.s3-ap-southeast-2.amazonaws.com/uploads360/dental-test/f35bc0e0-facd-41af-a659-53f5b2d0069b",
          },
      },
    ],
    startDate: "November 4, 2025",
  };

  this.http.post(url, data, { responseType: 'blob' }).subscribe((blob) => {

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `Certificate_${data.first_name}.pdf`;
    link.click();
  }, (err) => {
    console.error('Error downloading PDF', err);
  });
}

// 

  prsentersConfig: SwiperConfigInterface = {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 1000,
      disableOnInteraction: false,
    },
    speed: 1000,
    spaceBetween: 10,
    effect: 'slide', 
  };



  certificateData:any;

async downloadCertificate(Data: any) {
  const userData = Data?.course_registered_users.find((data: any) => data.status === 'COMPLETED');

  function formatDate(dateStr: string): string {
    const dateObj = new Date(dateStr);
    return dateObj.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  const formattedStart = formatDate(Data?.startDate);
  const formattedEnd = formatDate(Data?.endDate);

  this.certificateData = {
    first_name: userData?.first_name,
    last_name: userData?.last_name,
    presenters: Data?.presenters || [],
    course_name: Data?.course_name,
    logo: Data?.dental_supplier?.logo?.url,
    company_name: Data?.company_name,
    startDate: formattedStart,
    endDate: formattedEnd,
    cpd_points: Data?.cpd_points
  };

console.log("this.certificateData>>>", this.certificateData);

 await new Promise(resolve => setTimeout(resolve, 300));

  const certificateElement = document.getElementById('certificate');
  if (!certificateElement) return;

  // STEP 1: Temporarily show it (but keep it off-screen)
  certificateElement.style.visibility = 'visible';
  certificateElement.style.position = 'absolute';
  certificateElement.style.top = '-9999px';
  certificateElement.style.left = '0';
  certificateElement.style.display = 'block';

  // STEP 2: Capture
  const canvas = await html2canvas(certificateElement, {
    scale: 2,
    useCORS: true,
    allowTaint: true,
    backgroundColor: '#ffffff' // ensures no transparency
  });

  // STEP 3: Hide again after rendering
  certificateElement.style.display = 'none';

  // STEP 4: Convert to PDF
  const imgData = canvas.toDataURL('image/png');
  const pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 10;

  pdf.addImage(imgData, 'PNG', margin, margin, pageWidth - margin * 2, pageHeight - margin * 2);
  pdf.save(`Certificate_${this.certificateData.first_name}.pdf`);
}

 


}
